// Press-release show more trigger

function pressRelease()
{
    const isPressPage = document.querySelector('#press-release');

    if (typeof(isPressPage) != 'undefined' && isPressPage != null) {
        const showMorePressRelease = document.querySelector('#press-release .show-more-btn');
        showMorePressRelease.onclick = () => {
            showMobileElements('press-release');
            showMorePressRelease.remove();
        };
    }

    function showMobileElements(parentSelector)
    {
        let mobilElms = document.getElementById(parentSelector).getElementsByClassName('mobile-hidden');
        Array.from(mobilElms).forEach((el) => {
            el.classList.remove('mobile-hidden');
        });
    }

}

export default function init()
{

    pressRelease();

}
